var _circle, _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _g4, _g5, _g6, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g7, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g8, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g9, _path51, _path52, _path53, _g0, _path54, _path55, _path56, _g1, _path57, _path58, _path59, _g10, _path60, _path61, _path62, _g11, _path63, _path64, _path65, _g12, _path66, _path67, _path68, _g13, _path69, _path70, _path71, _g14, _path72, _path73, _path74, _g15, _path75, _path76, _path77, _g16, _path78, _path79, _path80, _g17, _path81, _path82, _path83, _g18, _path84, _path85, _path86, _g19, _path87, _path88, _g20, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfinandoTourComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 216,
    viewBox: "0 0 255 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131.725,
    cy: 121.13,
    r: 94.826,
    fill: "#F3E9FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 48,
    width: 111,
    height: 148
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.671 48.7107H254.636V195.818H144.671V48.7107Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.498 195.827H154.941C149.299 195.827 144.728 191.253 144.728 185.613V59.2407C144.728 53.599 149.299 49.0247 154.941 49.0247H244.498C250.142 49.0247 254.712 53.599 254.712 59.2407V185.613C254.712 191.253 250.142 195.827 244.498 195.827Z",
    fill: "#662D91"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.514 182.049H154.924V62.8047H244.514V182.049Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 37,
    width: 57,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 37.9946H227.965V67.2212H171.46V37.9946Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.796 66.9033H171.643V45.9271C171.643 41.5412 175.198 37.9831 179.586 37.9831H219.854C224.242 37.9831 227.796 41.5412 227.796 45.9271V66.9033Z",
    fill: "#737373"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.109 42.8275H184.527C181.945 42.8275 179.85 44.9224 179.85 47.5045C179.85 50.0865 181.945 52.1777 184.527 52.1777H193.109V42.8275Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.914 42.8275H206.331V52.1777H214.914C217.496 52.1777 219.589 50.0865 219.589 47.5045C219.589 44.9224 217.496 42.8275 214.914 42.8275Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.184 93.5251H230.937",
    stroke: "#662D91",
    strokeWidth: 4.74932,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.088 113.619H230.841",
    stroke: "#662D91",
    strokeOpacity: 0.6,
    strokeWidth: 4.74932,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.184 133.712H230.937",
    stroke: "#662D91",
    strokeWidth: 4.74932,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195.184 153.805H230.937",
    stroke: "#662D91",
    strokeOpacity: 0.62,
    strokeWidth: 4.74932,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M178.171 100.678H165.114V87.621H178.171V100.678Z",
    stroke: "#662D91",
    strokeWidth: 2.38644,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M178.171 130.54H165.114V117.485H178.171V130.54Z",
    stroke: "#662D91",
    strokeWidth: 2.38644,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.171 160.404H165.114V147.347H178.171V160.404Z",
    stroke: "#662D91",
    strokeWidth: 2.38644,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.355 91.8129L173.401 96.6516L184.759 77.3024",
    stroke: "#25BA72",
    strokeWidth: 2.38644,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.355 121.719L173.401 126.556L184.759 107.207",
    stroke: "#25BA73",
    strokeWidth: 2.38644,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M168.355 151.622L173.401 156.461L184.759 137.112",
    stroke: "#25BA72",
    strokeWidth: 2.38644,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.0017 201.51C33.1247 201.51 11.3366 197.363 11.3366 192.248C11.3366 187.133 33.1247 182.987 60.0017 182.987C86.8787 182.987 108.667 187.133 108.667 192.248C108.667 197.363 86.8787 201.51 60.0017 201.51Z",
    fill: "black",
    fillOpacity: 0.38
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.407 129.076L111.222 122.927C111.331 122.689 111.266 122.338 111.062 122.041L108.902 118.925C108.56 118.431 107.984 118.284 107.765 118.64L103.32 125.879C103.065 126.296 103.332 126.992 103.86 127.28L107.556 129.285C107.912 129.476 108.264 129.389 108.407 129.076Z",
    fill: "#E6B64D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.3 129.755L103.013 126.908C102.795 126.792 102.658 126.524 102.709 126.314C102.76 126.103 102.979 126.029 103.196 126.148L108.446 129.01C108.643 129.118 108.772 129.371 108.733 129.575C108.693 129.783 108.499 129.863 108.3 129.755Z",
    fill: "#F4A525"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.856 138.822C109.228 137.711 107.968 136.229 107.032 134.698C106.914 134.502 106.798 134.308 106.688 134.107C104.528 130.209 105.515 129.164 106.63 125.145C104.318 126.331 101.7 127.194 99.1307 127.607C95.972 128.119 92.7688 128.108 89.6653 127.745C88.0711 127.558 86.3387 127.128 84.8766 128.004C84.2932 128.354 83.3767 129.312 83.7125 130.267C83.8528 130.667 84.075 131.012 84.3191 131.317C85.5441 132.837 87.307 133.331 88.9717 133.66C89.5548 133.775 90.1287 133.927 90.7117 134.084C91.397 134.269 92.0878 134.455 92.7801 134.639C93.7053 134.887 94.64 135.134 95.5817 135.381C96.6604 135.664 97.7503 135.946 98.8497 136.228C99.9865 136.518 101.133 136.809 102.293 137.095C103.382 137.363 104.482 137.63 105.593 137.886C106.515 138.099 107.447 138.309 108.39 138.497C109.019 138.622 109.654 138.751 110.299 138.815C110.477 138.831 110.679 138.867 110.858 138.818",
    fill: "#FAFAFA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8972 152.245L64.001 155.724L61.8794 162.436C61.8717 164.727 61.8659 167.019 61.8582 169.31C61.8524 171.207 61.8467 173.103 61.8409 174.998C61.8351 177.099 61.737 179.195 61.7832 181.3C61.812 182.656 61.9563 184.016 62.3199 185.326C63.1085 188.161 64.9705 190.384 67.7384 191.414C70.8969 192.587 74.4458 192.698 77.7773 192.562C79.8028 192.479 81.8263 192.166 83.7614 191.556C85.5233 191.002 87.7335 190.244 88.7144 188.547C89.8166 186.641 89.1684 183.452 88.776 181.425C88.2778 178.845 87.4584 176.345 86.8198 173.798C86.2177 171.393 85.6118 168.991 84.9982 166.59C84.2673 163.736 83.5267 160.881 82.7477 158.038C82.2629 156.271 81.909 154.255 81.0992 152.597C81.0819 152.562 80.9646 152.231 80.8972 152.245Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4655 172.881C86.4655 172.881 86.327 172.917 86.0654 172.987C85.8038 173.058 85.4344 173.189 84.9613 173.366C84.7285 173.462 84.465 173.568 84.2245 173.775C84.1091 173.877 83.9918 174.037 84.013 174.233C84.0303 174.395 84.0476 174.564 84.0649 174.737C84.1361 175.433 84.2226 176.218 84.34 177.072C84.4535 177.924 84.6054 178.855 84.8112 179.815C84.8593 180.044 84.8151 180.231 84.642 180.369C84.5592 180.438 84.4554 180.498 84.3457 180.55C84.2284 180.61 84.1188 180.654 84.0033 180.7C83.534 180.879 83.0223 180.985 82.4972 181.067C81.9721 181.15 81.4239 181.21 80.8738 181.31C80.3294 181.408 79.7774 181.506 79.2215 181.606C78.6656 181.702 78.1058 181.794 77.5442 181.864C77.2633 181.898 76.9806 181.929 76.6978 181.952C76.4112 181.975 76.1323 182.004 75.9034 181.941C75.788 181.908 75.6937 181.854 75.6149 181.769C75.5437 181.692 75.486 181.579 75.4437 181.458C75.4013 181.337 75.3725 181.198 75.3379 181.058L75.2475 180.644C75.1321 180.09 75.0455 179.53 74.9685 178.973C74.8955 178.413 74.8243 177.857 74.7531 177.309C74.7166 177.034 74.6819 176.761 74.6473 176.487C74.6012 176.208 74.5223 175.897 74.2818 175.67C74.1645 175.558 74.0126 175.487 73.8664 175.451C73.7125 175.414 73.5682 175.414 73.4297 175.418C73.1662 175.435 72.9046 175.451 72.6449 175.468C72.1314 175.499 71.6255 175.516 71.133 175.526C70.1501 175.547 69.2191 175.535 68.3593 175.516C67.4995 175.495 66.7109 175.476 66.0145 175.437C65.3182 175.399 64.7104 175.341 64.2141 175.281C63.7179 175.222 63.3312 175.137 63.0773 175.052C62.8215 174.974 62.6945 174.9 62.6945 174.9C62.6945 174.9 62.8157 174.979 63.0716 175.07C63.3235 175.164 63.7083 175.27 64.2064 175.345C64.7046 175.42 65.3086 175.499 66.0069 175.56C66.7051 175.624 67.4937 175.668 68.3536 175.705C69.2134 175.741 70.1482 175.772 71.1369 175.77C71.6312 175.77 72.1391 175.762 72.6584 175.741C72.9181 175.731 73.1835 175.716 73.4413 175.703C73.5663 175.697 73.6894 175.703 73.7952 175.728C73.9048 175.756 74.0049 175.805 74.0818 175.88C74.2415 176.026 74.3146 176.274 74.353 176.526C74.3857 176.795 74.4203 177.068 74.453 177.341C74.5204 177.892 74.5877 178.447 74.6569 179.009C74.73 179.571 74.8147 180.138 74.9282 180.704L75.0186 181.129C75.0513 181.267 75.0801 181.41 75.1301 181.56C75.1821 181.708 75.2494 181.86 75.3725 181.994C75.4879 182.121 75.6514 182.216 75.813 182.26C76.1419 182.348 76.4477 182.3 76.7286 182.279C77.0171 182.254 77.3037 182.221 77.5884 182.185C78.1597 182.11 78.7233 182.014 79.2811 181.914C79.837 181.81 80.3871 181.708 80.9315 181.606C81.472 181.502 82.0106 181.44 82.5472 181.354C83.082 181.265 83.6129 181.158 84.1091 180.958C84.2342 180.906 84.3611 180.85 84.4708 180.792C84.59 180.733 84.7093 180.663 84.8189 180.569C84.8728 180.521 84.9247 180.467 84.967 180.404C84.9882 180.373 85.0074 180.338 85.0267 180.3C85.0382 180.275 85.0555 180.229 85.0632 180.194C85.1036 180.044 85.0863 179.896 85.0613 179.767C84.8343 178.801 84.6689 177.895 84.5362 177.043C84.4054 176.195 84.2996 175.412 84.2015 174.72C84.1784 174.547 84.1534 174.379 84.1322 174.218C84.1111 174.079 84.1938 173.946 84.2976 173.848C84.5112 173.65 84.7689 173.533 84.994 173.433C85.4575 173.246 85.8249 173.094 86.0769 173.008C86.3289 172.925 86.4655 172.881 86.4655 172.881Z",
    fill: "#662D91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.3369 185.33C61.9734 184.02 61.8291 182.66 61.8002 181.304C61.7541 179.199 61.8502 177.101 61.8579 175.002C61.8637 173.106 61.8695 171.209 61.8752 169.314C61.8829 167.024 61.8887 164.731 61.8964 162.44L64.0181 155.729C64.0181 155.729 65.3722 155.45 67.315 155.05C65.4915 162.055 61.6579 181.129 70.3868 192.154C69.4905 191.976 68.6076 191.739 67.7555 191.422C64.9856 190.389 63.1255 188.167 62.3369 185.33Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_9851)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7195 160.965C52.7195 160.965 44.6273 149.031 40.1224 148.648C39.0798 148.56 37.9546 149.801 37.3563 150.443C34.5499 153.459 32.6572 157.268 31.2453 161.136C29.7065 165.35 28.1023 169.572 27.2463 174.022C26.4884 177.957 26.021 182.66 27.5137 186.58C28.9986 190.477 34.5461 192.391 38.1892 193.22C41.7593 194.032 46.0026 194.778 49.5015 193.747C55.6356 191.939 53.5832 184.791 53.1831 179.879C52.7041 174.008 52.079 167.922 52.5887 162.078C52.6195 161.707 52.6599 161.334 52.7195 160.965Z",
    fill: "url(#paint0_linear_1_9851)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.6923 176.478C52.6923 176.478 52.5538 176.476 52.2941 176.474C52.0344 176.472 51.6536 176.468 51.1688 176.478C50.6841 176.485 50.0955 176.497 49.4203 176.522C49.0818 176.535 48.7221 176.553 48.3432 176.579C47.9662 176.616 47.5642 176.626 47.1448 176.756C46.9371 176.822 46.7293 176.931 46.562 177.097C46.3908 177.257 46.2715 177.474 46.185 177.684C46.0023 178.118 45.9407 178.593 45.883 179.067C45.833 179.536 45.7483 180.019 45.6964 180.521C45.6676 180.771 45.6445 181.023 45.6214 181.277C45.6002 181.533 45.5752 181.773 45.4848 181.988C45.3983 182.202 45.2405 182.371 45.0328 182.473C44.8231 182.579 44.5827 182.61 44.3307 182.598C44.0787 182.589 43.8133 182.544 43.5401 182.515C43.2708 182.489 43.0016 182.462 42.7303 182.435C41.6512 182.304 40.551 182.181 39.4507 182.037C38.9025 181.969 38.3562 181.898 37.8253 181.786C37.5599 181.731 37.2964 181.667 37.0386 181.588C36.9097 181.548 36.7828 181.508 36.6578 181.459C36.5289 181.415 36.4231 181.365 36.3173 181.3C36.2154 181.236 36.1115 181.154 36.0365 181.071C35.9365 180.963 35.8845 180.884 35.823 180.771C35.7095 180.554 35.6498 180.307 35.6191 180.053C35.5883 179.798 35.5825 179.538 35.5767 179.272C35.5729 179.007 35.5537 178.74 35.5383 178.482C35.5075 177.964 35.4787 177.455 35.4498 176.957C35.4363 176.708 35.4267 176.462 35.419 176.218C35.4094 175.974 35.4152 175.739 35.3959 175.489C35.3786 175.241 35.3055 174.979 35.1593 174.769C35.0189 174.564 34.8304 174.396 34.6246 174.277C34.5227 174.217 34.4149 174.167 34.3034 174.129C34.1976 174.094 34.0937 174.06 33.9918 174.025C33.7859 173.958 33.584 173.89 33.3878 173.825C31.8086 173.306 30.4794 172.911 29.5446 172.65C29.0772 172.521 28.7059 172.43 28.4501 172.38C28.1943 172.327 28.0558 172.33 28.0558 172.33C28.0558 172.33 28.1962 172.332 28.4462 172.398C28.6982 172.457 29.0637 172.569 29.5253 172.711C30.4506 172.998 31.7586 173.456 33.3262 174.004C33.5224 174.073 33.7225 174.144 33.9264 174.215C34.0283 174.252 34.1303 174.289 34.2322 174.325C34.3284 174.362 34.4246 174.406 34.513 174.462C34.6919 174.571 34.8516 174.718 34.967 174.896C35.0824 175.071 35.1382 175.279 35.1516 175.504C35.1632 175.729 35.1536 175.977 35.1593 176.222C35.1613 176.468 35.167 176.716 35.1747 176.966C35.1882 177.468 35.219 177.978 35.2459 178.497C35.2594 178.759 35.2767 179.015 35.2786 179.276C35.2825 179.54 35.2863 179.811 35.3171 180.086C35.3498 180.361 35.4132 180.648 35.5479 180.911C35.6114 181.038 35.7152 181.182 35.8018 181.273C35.9095 181.392 36.0211 181.481 36.15 181.563C36.2731 181.642 36.4173 181.71 36.5481 181.754C36.6789 181.804 36.8117 181.848 36.9463 181.892C37.2137 181.975 37.4868 182.044 37.7599 182.104C38.3081 182.223 38.8621 182.3 39.4123 182.371C40.5106 182.51 41.6147 182.625 42.7015 182.748C42.9727 182.773 43.2439 182.798 43.5132 182.823C43.7767 182.848 44.0441 182.892 44.3269 182.902C44.6058 182.912 44.9097 182.875 45.1732 182.741C45.3059 182.673 45.429 182.585 45.531 182.475C45.6329 182.364 45.7099 182.235 45.7656 182.102C45.8772 181.835 45.9003 181.554 45.9195 181.304C45.9426 181.05 45.9638 180.8 45.9869 180.552C46.0292 180.057 46.1023 179.572 46.1446 179.095C46.1908 178.624 46.2427 178.168 46.4004 177.77C46.4812 177.566 46.5774 177.387 46.7197 177.247C46.8582 177.105 47.0313 177.007 47.2179 176.943C47.593 176.816 47.9969 176.793 48.3701 176.751C48.7452 176.712 49.103 176.681 49.4396 176.658C50.1128 176.61 50.6995 176.576 51.1842 176.551C52.1383 176.503 52.6923 176.478 52.6923 176.478Z",
    fill: "#662D91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.5115 186.567C26.0189 182.648 26.4863 177.944 27.2441 174.008C28.1001 169.559 29.7043 165.337 31.2431 161.122C32.6569 157.252 34.5497 153.444 37.3542 150.429C37.9524 149.787 39.0796 148.546 40.1202 148.635C41.1204 148.719 42.2957 149.373 43.521 150.339C38.516 156.641 28.5829 172.208 33.4956 191.728C30.8911 190.62 28.4271 188.971 27.5115 186.567Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1847 120.551L79.6853 118.035C79.6853 118.035 77.0924 115.682 72.6702 114.961C72.726 114.886 55.0546 111.12 52.6559 113.699C52.5886 113.766 52.9945 117.373 52.9945 117.373L63.2507 119.243L77.1847 120.551Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6853 118.033C85.7078 123.898 88.4469 132.904 86.1021 142.02C82.5744 155.732 68.8847 164.502 55.5258 161.605C42.1669 158.708 34.1959 145.243 37.7217 131.531C39.826 123.35 45.5466 116.931 52.6559 113.696C53.2426 113.93 53.8312 114.151 54.4217 114.35C62.537 117.068 71.516 118.143 79.6853 118.033Z",
    fill: "url(#paint1_linear_1_9851)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.7215 131.532C39.8259 123.352 45.5464 116.933 52.6558 113.697C52.8212 113.765 52.9886 113.826 53.154 113.89C47.2622 117.396 42.6477 123.209 40.8049 130.371C37.2772 144.083 45.2483 157.548 58.6091 160.445C62.8428 161.362 67.1091 161.108 71.0754 159.897C66.2897 162.051 60.8808 162.767 55.5257 161.605C42.1649 158.71 34.1938 145.245 37.7215 131.532Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3118 120.784C70.3118 120.784 70.3272 120.894 70.3561 121.101C70.383 121.309 70.4157 121.613 70.4561 122C70.4945 122.386 70.533 122.858 70.5676 123.398C70.5888 123.667 70.5984 123.956 70.6119 124.258C70.6292 124.56 70.6369 124.879 70.6446 125.212C70.6561 125.545 70.658 125.891 70.6561 126.249C70.6561 126.428 70.658 126.61 70.658 126.795C70.6542 126.98 70.6504 127.168 70.6465 127.359C70.6369 127.739 70.633 128.13 70.6042 128.528C70.5753 128.926 70.5734 129.334 70.5311 129.748C70.4945 130.161 70.4676 130.58 70.4195 131.006C70.3695 131.429 70.3195 131.858 70.2676 132.289C70.2022 132.718 70.1348 133.15 70.0675 133.585C70.0021 134.02 69.9002 134.451 69.8194 134.883C69.7444 135.318 69.6386 135.747 69.5347 136.174C69.4308 136.605 69.3366 137.024 69.2135 137.447C69.0981 137.871 68.9827 138.288 68.8692 138.704C68.7499 139.113 68.6326 139.519 68.5172 139.917C68.3941 140.314 68.2709 140.704 68.1536 141.085C68.0344 141.468 67.9055 141.837 67.7882 142.199C67.54 142.918 67.2957 143.595 67.0553 144.216C66.936 144.526 66.8091 144.818 66.6975 145.101C66.5782 145.38 66.4648 145.644 66.3532 145.89C66.1243 146.378 65.9223 146.805 65.7357 147.146C65.553 147.488 65.3953 147.75 65.2837 147.927C65.1702 148.102 65.101 148.19 65.101 148.19C65.101 148.19 65.4145 147.869 65.8454 147.213C66.0647 146.888 66.309 146.48 66.5744 146.001C66.7052 145.761 66.8379 145.503 66.9803 145.232C67.113 144.957 67.2553 144.668 67.3957 144.363C67.5304 144.055 67.6804 143.739 67.8208 143.405C67.9574 143.07 68.1036 142.726 68.2402 142.366C68.3748 142.006 68.521 141.639 68.6576 141.258C68.7922 140.877 68.925 140.487 69.0596 140.09C69.1866 139.69 69.3174 139.283 69.4482 138.871C69.579 138.459 69.6944 138.042 69.8155 137.619C69.9406 137.201 70.0464 136.759 70.1541 136.328C70.2618 135.893 70.3753 135.459 70.4542 135.016C70.533 134.574 70.633 134.135 70.6946 133.693C70.7581 133.25 70.8235 132.81 70.8869 132.371C70.9312 131.931 70.9735 131.496 71.0177 131.065C71.0562 130.634 71.0716 130.205 71.0985 129.786C71.1293 129.367 71.1274 128.953 71.1351 128.549C71.1466 128.145 71.1351 127.749 71.1293 127.364C71.1255 126.98 71.112 126.605 71.0889 126.243C71.0716 125.881 71.0485 125.533 71.0177 125.198C70.9677 124.529 70.8908 123.917 70.8158 123.379C70.7427 122.838 70.658 122.371 70.5869 121.988C70.5138 121.603 70.4426 121.305 70.3964 121.101C70.3387 120.892 70.3118 120.784 70.3118 120.784Z",
    fill: "#662D91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6527 129.107C75.0223 131.165 74.8549 134.347 73.2776 136.213C71.7023 138.078 69.3133 137.923 67.9437 135.864C66.5742 133.806 66.7415 130.625 68.3188 128.759C69.8961 126.891 72.2851 127.049 73.6527 129.107Z",
    fill: "#CCA244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9479 135.857C66.5783 133.799 66.7457 130.617 68.323 128.751C68.6557 128.359 69.0231 128.055 69.4117 127.842C70.1445 128.059 70.8332 128.571 71.366 129.373C72.7355 131.431 72.5682 134.612 70.9909 136.478C70.6581 136.871 70.2907 137.175 69.9022 137.388C69.1674 137.169 68.4807 136.657 67.9479 135.857Z",
    fill: "#FFCA55"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M69.5634 132.487C69.0209 132.012 68.44 131.192 68.692 130.329C68.9113 129.575 69.7211 129.394 70.2751 129.761C71.5658 130.619 71.1772 133.903 69.5634 132.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8824 128.099C69.7366 125.904 72.5469 126.087 74.1569 128.509C75.7669 130.931 75.5707 134.674 73.7164 136.869C71.8621 139.063 69.0519 138.881 67.4419 136.459C65.8299 134.037 66.0281 130.296 67.8824 128.099ZM67.9458 135.863C69.3154 137.921 71.7025 138.077 73.2798 136.211C74.8551 134.345 75.0244 131.163 73.6549 129.105C72.2853 127.047 69.8982 126.891 68.3209 128.757C66.7436 130.623 66.5763 133.804 67.9458 135.863Z",
    fill: "#662D91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1811 137.576C70.3023 137.599 70.4254 137.613 70.5504 137.621C71.5852 137.68 72.5836 137.205 73.3626 136.284C74.9668 134.385 75.138 131.138 73.7454 129.045C73.0587 128.011 72.0988 127.409 71.0486 127.349C70.0137 127.289 69.0154 127.764 68.2364 128.686C66.6322 130.584 66.461 133.831 67.8536 135.924C68.4595 136.836 69.2751 137.411 70.1811 137.576ZM73.5607 129.169C74.9014 131.186 74.7379 134.314 73.1933 136.141C72.4604 137.009 71.5256 137.455 70.5639 137.401C69.5829 137.344 68.6865 136.778 68.0383 135.803C66.6976 133.785 66.8611 130.657 68.4057 128.83C69.1385 127.963 70.0734 127.516 71.0351 127.57C72.0161 127.626 72.9125 128.193 73.5607 129.169Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.848 123.78L113.149 130.653C113.247 131.174 113.588 131.524 113.891 131.418L119.324 129.525C119.575 129.437 119.687 128.985 119.569 128.527L118.465 124.154C118.372 123.785 118.152 123.507 117.932 123.481L112.308 122.823C111.963 122.784 111.744 123.237 111.848 123.78Z",
    fill: "#FFBD39"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.755 132.351L115.218 139.08C115.264 139.764 115.656 140.228 116.047 140.072L122.851 137.358C123.139 137.244 123.31 136.719 123.238 136.177L122.694 132.087C122.628 131.592 122.379 131.225 122.106 131.224L115.375 131.186C114.995 131.184 114.71 131.714 114.755 132.351Z",
    fill: "#FFBD39"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.93 125.903L115.286 132.223C115.525 132.866 116.033 133.199 116.363 132.938L122.116 128.403C122.359 128.212 122.374 127.66 122.151 127.161L120.468 123.393C120.264 122.938 119.92 122.657 119.658 122.733L113.194 124.61C112.829 124.716 112.707 125.305 112.93 125.903Z",
    fill: "#FFBD39"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M112.442 123.61L114.974 138.753C115.114 139.593 114.691 140.38 114.136 140.29L107.108 139.152C106.719 139.09 106.392 138.696 106.281 138.156L104.119 127.57C103.99 126.935 104.207 126.313 104.632 126.087L111.261 122.578C111.734 122.331 112.312 122.84 112.442 123.61Z",
    fill: "#FFBD39"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.573 140.338L111.674 123.023C111.624 122.721 111.735 122.469 111.922 122.458C112.108 122.448 112.299 122.681 112.349 122.98L115.233 140.134C115.285 140.444 115.181 140.743 114.999 140.799C114.816 140.857 114.625 140.651 114.573 140.338Z",
    fill: "#F4A525"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.112 26.4064C114.139 26.3798 116.605 29.41 116.617 33.1752C116.632 36.9419 114.19 40.0156 111.164 40.0442C108.137 40.0708 105.671 37.0406 105.658 33.2754C105.643 29.5086 108.085 26.433 111.112 26.4064ZM109.095 33.2441C109.101 34.8811 110.013 36.2012 111.13 36.1908C112.248 36.1804 113.15 34.8445 113.144 33.2075C113.137 31.5705 112.226 30.2504 111.108 30.2608C109.988 30.2696 109.089 31.6052 109.095 33.2441Z",
    fill: "#662D91"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.599 26.4482C108.266 27.2487 106.555 29.9168 106.568 33.0693C106.583 36.836 109.048 39.8666 112.074 39.8381C112.25 39.8363 112.423 39.8233 112.596 39.8026C112.141 39.9584 111.664 40.0442 111.172 40.0486C108.145 40.0753 105.679 37.0451 105.667 33.2799C105.654 29.7339 107.819 26.8002 110.599 26.4482Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M109.631 39.1581C109.962 38.945 110.282 38.8223 110.671 38.8333C111.01 38.844 111.341 38.9365 111.66 39.0527C111.832 39.1162 112.18 39.2681 112.135 39.5309C112.136 39.5328 112.011 40.2648 112.011 40.2648L108.401 66.0088C108.401 66.0088 106.255 69.1581 104.342 69.5372C104.334 69.5484 104.888 65.2892 104.888 65.2892L108.548 39.2813C108.931 39.2269 109.295 39.3737 109.631 39.1581Z",
    fill: "#662D91"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.797 69.3954C104.644 69.4574 104.493 69.5054 104.342 69.5357C104.334 69.547 104.888 65.2877 104.888 65.2877L108.548 39.2798C108.697 39.2597 108.843 39.2693 108.986 39.2759L105.335 65.2175C105.337 65.2171 104.863 68.8526 104.797 69.3954Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6178 55.0589C91.6178 55.0589 91.6254 55.0675 91.6395 55.0788C91.6177 55.0689 91.6108 55.0642 91.6178 55.0589Z",
    fill: "#361256"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1855 57.5048C92.7815 56.1676 91.7849 55.2178 91.6375 55.0791C91.7929 55.1458 92.7108 55.4274 94.1855 57.5048Z",
    fill: "#361256"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M111.569 69.5216C113.956 69.2571 116.428 71.2917 116.304 71.276C121.995 76.4616 117.491 86.7555 117.607 86.8354C115.647 94.6588 109.104 93.1169 109.104 93.1169C109.104 93.1169 95.4186 59.6195 95.4359 59.4929C94.9838 58.6913 94.5674 58.0375 94.187 57.5023C92.7104 55.4253 91.7947 55.1452 91.6389 55.0766C91.627 55.0652 91.6176 55.0572 91.6176 55.0572C109.805 61.9793 111.365 69.6226 111.569 69.5216Z",
    fill: "#662D91"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.3512 51.796C74.0592 51.8665 74.7665 51.943 75.4713 52.0278C84.71 53.1355 94.1936 55.2658 101.428 60.4374C116.764 71.4007 113.189 90.4213 105.005 102.457C103.996 103.941 102.812 105.347 101.407 106.61C96.1384 111.338 88.2452 113.651 80.4199 114.93C71.9585 116.312 62.4491 116.555 53.7781 114.875C45.7063 113.311 37.7846 108.233 32.8437 103.01C30.0035 100.009 27.3244 96.3029 26.2141 92.7067C24.7167 87.8524 25.2544 82.1108 25.6568 77.2635C26.0775 72.1701 27.2128 66.7859 31.1641 62.7436C35.2025 58.6124 41.5738 55.6576 47.7181 53.7241C55.6753 51.2208 64.6446 50.9367 73.3512 51.796Z",
    fill: "url(#paint2_linear_1_9851)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M25.6583 77.2634C26.0791 72.1701 27.2143 66.7858 31.1657 62.7435C31.2477 62.6596 31.3336 62.5749 31.418 62.4925C28.7028 66.2497 27.8208 70.8152 27.4623 75.1669C27.0618 80.0138 26.5222 85.7558 28.0196 90.6101C29.1299 94.2062 31.809 97.9127 34.6491 100.914C39.5897 106.135 47.5099 111.215 55.5836 112.778C64.2545 114.458 73.7639 114.216 82.2254 112.833C90.0507 111.554 97.942 109.242 103.213 104.513C103.568 104.196 103.908 103.868 104.234 103.532C103.405 104.622 102.47 105.656 101.409 106.61C96.1399 111.338 88.2467 113.651 80.4214 114.93C71.96 116.312 62.4506 116.555 53.7796 114.875C45.7079 113.311 37.7861 108.233 32.8452 103.01C30.005 100.009 27.3259 96.3028 26.2156 92.7066C24.7182 87.8524 25.2578 82.1103 25.6583 77.2634Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.476 85.3978L37.5363 81.1355C37.6885 70.3326 46.1635 61.9192 56.1127 62.3297L93.8854 63.8863C102.119 64.2259 108.481 72.0862 108.348 81.4528L108.297 85.1478C108.165 94.5144 101.581 102.369 93.3387 102.7L55.5219 104.221C45.5609 104.623 37.3238 96.2008 37.476 85.3978Z",
    fill: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0607 65.2493C26.2189 63.143 27.6159 61.1719 29.1887 59.3556C37.6 49.6448 50.6283 44.0689 63.3739 43.7583C72.8114 43.529 83.5364 44.3183 92.2051 48.3299C108.771 55.9971 111.209 69.6661 111.209 69.6661C111.004 69.7671 109.445 62.1256 91.2559 55.2038C90.7382 54.5319 88.7985 54.0627 88.0107 53.7449C86.9116 53.3017 85.7947 52.8989 84.6641 52.5379C82.4048 51.8156 80.0923 51.2578 77.7542 50.8556C73.1545 50.0622 68.4386 49.8172 63.7889 50.2682C52.4235 51.3725 41.8969 57.0027 35.5494 66.6349C35.4276 66.8202 33.341 70.1619 33.4777 70.2438C33.4755 70.2423 25.0607 65.2493 25.0607 65.2493Z",
    fill: "#662D91"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.3611 45.0638C52.6155 45.3745 39.5872 50.9503 31.1759 60.6611C29.6256 62.4516 28.2483 64.3917 27.0992 66.463C25.9272 65.7673 25.064 65.2562 25.064 65.2562C26.2222 63.1499 27.6191 61.1788 29.1919 59.3625C37.6032 49.6517 50.6315 44.0758 63.3771 43.7652C72.8147 43.5359 83.5396 44.3252 92.2084 48.3368C94.5536 49.4227 96.616 50.6283 98.4283 51.8985C97.1299 51.1032 95.721 50.3444 94.1905 49.6358C85.5233 45.6219 74.7983 44.8326 65.3611 45.0638Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M38.164 13.6422C41.7238 13.4116 44.8203 16.4956 45.0834 20.5308C45.3446 24.5664 42.6733 28.0257 39.1135 28.2562C35.5536 28.4867 32.4571 25.4028 32.194 21.3676C31.9309 17.3324 34.6041 13.8727 38.164 13.6422ZM36.2353 21.1053C36.3499 22.8609 37.5082 24.2129 38.8212 24.1286C40.1362 24.0439 41.1084 22.5519 40.9957 20.7959C40.883 19.04 39.7228 17.6883 38.4097 17.7726C37.0951 17.8592 36.121 19.3516 36.2353 21.1053Z",
    fill: "#662D91"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.5621 13.7196C34.8698 14.7344 33.0312 17.7084 33.251 21.0863C33.5122 25.1219 36.6106 28.2055 40.1704 27.9749C40.3773 27.9615 40.5821 27.9367 40.7828 27.9009C40.2603 28.0989 39.7043 28.223 39.124 28.2596C35.5641 28.4902 32.4677 25.4062 32.2046 21.371C31.9583 17.5714 34.3153 14.2827 37.5621 13.7196Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2515 27.408C37.6271 27.1573 37.9956 27.0039 38.4553 26.9919C38.8542 26.9796 39.2486 27.0581 39.6322 27.1622C39.8406 27.219 40.2584 27.3596 40.2235 27.6422C40.2238 27.6441 40.1263 28.4374 40.1263 28.4374L37.5536 56.2726C37.5536 56.2726 35.2321 59.7915 33.0073 60.325C32.998 60.3385 33.3738 55.735 33.3738 55.735L35.9883 27.6121C36.4329 27.5305 36.8705 27.6616 37.2515 27.408Z",
    fill: "#662D91"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.5329 60.1445C33.3573 60.2205 33.1811 60.283 33.0067 60.3236C32.9975 60.3371 33.3733 55.7336 33.3733 55.7336L35.9878 27.6107C36.1617 27.578 36.3341 27.5789 36.5039 27.5763L33.8956 55.6276C33.894 55.6299 33.5752 59.5572 33.5329 60.1445Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3457 68.323C34.8653 69.3801 35.1727 70.5573 35.3287 71.8667C35.7677 75.5361 35.2239 79.2454 34.3513 82.809C33.3734 86.8015 32.5381 90.4599 30.0223 93.7882C29.2136 94.6819 28.7389 95.0099 27.6246 95.0686C26.7488 95.1157 25.8697 95.1244 24.993 95.0836C21.4894 94.9258 17.807 93.9209 15.2031 91.4588C12.6522 89.0493 11.8876 85.5742 11.869 82.1839C11.8453 77.7769 12.5079 73.2624 13.3711 68.9509C13.7969 66.8217 14.585 65.652 16.3093 64.3709C20.7516 61.0661 27.477 62.0374 31.7159 65.212C32.9186 66.1133 33.766 67.1441 34.3457 68.323Z",
    fill: "#662D91"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.3909 68.9313C13.8167 66.8021 14.6048 65.6323 16.3291 64.3513C20.7713 61.0465 27.4967 62.0178 31.7356 65.1924C32.3598 65.6603 32.8848 66.1625 33.3305 66.7011C29.0868 63.5529 22.3962 62.6005 17.9714 65.8941C16.2475 67.1771 15.459 68.345 15.0332 70.4742C14.17 74.7856 13.5074 79.3001 13.5311 83.7072C13.5484 86.7571 14.1727 89.8711 16.1524 92.2196C15.8308 91.9767 15.5199 91.7181 15.2229 91.4392C12.672 89.0297 11.9074 85.5546 11.8888 82.1643C11.865 77.7572 12.528 73.2446 13.3909 68.9313Z",
    fill: "black"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9805 138.637C23.0222 137.75 25.1619 137.443 27.1276 137.479C27.3782 137.484 27.6221 137.492 27.8706 137.507C32.6164 137.801 32.949 139.329 35.7539 142.653C36.0812 139.856 36.8646 136.956 38.0012 134.355C39.3972 131.153 41.2533 128.233 43.3387 125.629C44.407 124.299 45.7474 123 45.8679 121.123C45.9161 120.372 45.6606 118.925 44.6843 118.612C44.275 118.481 43.8612 118.458 43.4673 118.484C41.4833 118.613 40.0335 119.913 38.7775 121.237C38.3357 121.703 37.8693 122.135 37.3886 122.574C36.8235 123.091 36.2558 123.612 35.6836 124.139C34.9187 124.844 34.1471 125.557 33.3685 126.281C32.4747 127.112 31.5706 127.955 30.6601 128.812C29.7156 129.701 28.7618 130.602 27.8022 131.523C26.898 132.388 25.9873 133.268 25.0742 134.167C24.314 134.916 23.5512 135.677 22.7989 136.464C22.2961 136.989 21.7854 137.521 21.3298 138.102C21.2035 138.262 21.0481 138.438 20.9839 138.637",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.703 138.052C22.8246 137.928 22.9477 137.805 23.0693 137.681C23.8525 136.893 24.6473 136.129 25.4376 135.377C26.3892 134.475 27.3365 133.593 28.2787 132.726C29.2801 131.804 30.2728 130.899 31.2571 130.01C32.2059 129.151 33.1468 128.306 34.078 127.474C34.8896 126.749 35.6922 126.034 36.4896 125.328C37.0858 124.801 37.6776 124.278 38.2653 123.76C38.7648 123.32 39.2513 122.885 39.7108 122.42C41.0186 121.092 42.5285 119.79 44.614 119.674C45.0277 119.651 45.4644 119.677 45.8973 119.814C46.3415 119.953 46.6456 120.301 46.8459 120.715C46.7403 119.967 46.3912 119.067 45.6074 118.82C45.1761 118.684 44.7397 118.656 44.3264 118.678C42.2442 118.786 40.7359 120.073 39.4293 121.387C38.9705 121.85 38.4838 122.277 37.9853 122.712C37.3975 123.224 36.8067 123.742 36.2119 124.263C35.4163 124.96 34.6134 125.669 33.804 126.384C32.8729 127.207 31.9342 128.043 30.9858 128.892C30.0036 129.772 29.0114 130.667 28.0125 131.577C27.0724 132.434 26.1256 133.307 25.1761 134.199C24.3859 134.942 23.5933 135.696 22.8118 136.477C22.2895 136.998 21.759 137.525 21.2853 138.103C21.1544 138.261 20.9935 138.434 20.9279 138.634C21.5164 138.398 22.1087 138.206 22.703 138.052Z",
    fill: "black"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0278 153.038L17.1184 143.178C16.3592 142.639 16.2941 141.431 16.9898 140.811L25.0436 133.628C25.4523 133.264 26.0184 133.213 26.48 133.497L35.5865 139.115C36.1347 139.453 36.3951 140.179 36.2071 140.841L32.956 152.265C32.6998 153.167 31.7486 153.548 31.0278 153.038Z",
    fill: "#FFBD39"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2299 140.634L33.6256 150.57C33.7319 150.643 33.7628 150.788 33.6976 150.895L33.3383 151.471C33.2714 151.578 33.1328 151.605 33.0264 151.532L18.6308 141.596C18.5244 141.522 18.4935 141.378 18.5588 141.271L18.918 140.694C18.9833 140.587 19.1236 140.56 19.2299 140.634Z",
    fill: "#F4A525"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.1903 143.093C17.2253 143.013 17.2697 142.94 17.3202 142.874L17.2925 142.856C17.0233 142.683 16.9305 142.323 17.0873 142.052C17.2441 141.78 17.5898 141.701 17.8607 141.874L17.9916 141.958C18.0627 141.742 18.1863 141.539 18.3674 141.375L26.155 134.3C26.4959 133.991 26.9595 133.896 27.3782 134.038L26.3953 133.508C25.9303 133.257 25.3707 133.328 24.9755 133.686L17.1879 140.761C17.0068 140.925 16.8832 141.128 16.812 141.344L16.6812 141.26C16.412 141.087 16.0662 141.166 15.9077 141.438C15.7509 141.709 15.8421 142.069 16.113 142.242L16.1407 142.26C16.0902 142.326 16.0474 142.399 16.0108 142.479",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7696 150.912L24.89 147.77C24.5222 147.534 24.1533 147.49 24.0835 147.676L22.7101 151.312C22.6416 151.495 22.8911 151.827 23.2601 152.041L26.7938 154.096C27.0925 154.269 27.3821 154.315 27.4977 154.208L30.2168 151.657C30.3703 151.515 30.1585 151.161 29.7696 150.912Z",
    fill: "#E6B64D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6418 146.901L19.0835 143.824C18.624 143.514 18.1455 143.451 18.0609 143.69L16.447 148.296C16.3719 148.513 16.6528 148.895 17.0811 149.156L20.3155 151.134C20.7068 151.373 21.0957 151.435 21.2263 151.278L24.1655 147.769C24.3139 147.59 24.0766 147.196 23.6418 146.901Z",
    fill: "#E6B64D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7965 88.896C70.7965 88.896 74.7105 90.6497 79.072 89.1256C79.0542 89.1333 79.0687 90.5561 79.0605 90.6514C78.9784 91.6684 78.771 92.693 78.3456 93.6185C77.6107 95.2119 75.7221 96.6749 73.8694 96.065C73.1939 95.842 72.6094 95.3368 72.1815 94.7821C70.9164 93.1453 70.7343 90.8688 70.7965 88.896Z",
    fill: "#666666"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3367 79.6213C92.6008 79.8012 93.804 80.1897 94.9151 80.7762C95.6709 81.1747 95.9617 82.1107 95.5632 82.8665C95.1646 83.6223 94.2257 83.913 93.4728 83.5145C91.8794 82.6751 89.9647 82.4013 88.2006 82.7626C87.3641 82.9342 86.5466 82.3929 86.3721 81.5562C86.2006 80.7197 86.742 79.8992 87.5785 79.7276C88.8112 79.4764 90.0755 79.4415 91.3367 79.6213Z",
    fill: "#666666"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6361 78.6815C59.9111 78.6096 61.1655 78.7541 62.3705 79.1107C63.1901 79.3532 63.6591 80.2149 63.4166 81.0344C63.1741 81.8539 62.3125 82.323 61.493 82.0805C59.7654 81.5703 57.8354 81.6787 56.1747 82.3765C55.3874 82.7075 54.479 82.3411 54.1451 81.5537C53.8112 80.7663 54.1805 79.858 54.9679 79.5241C56.1295 79.0367 57.361 78.7534 58.6361 78.6815Z",
    fill: "#666666"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 49,
    width: 94,
    height: 66
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M113.456 49.4542L29.4622 63.9175L38.185 114.574L122.178 100.111L113.456 49.4542Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 64,
    width: 37,
    height: 38
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0865 70.1184L109.002 64.7949L114.454 96.4554L83.5383 101.779L78.0865 70.1184Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2083 62.7379L116.286 67.6288L114.205 101.297L35.1257 96.4066L37.2083 62.7379Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2083 62.7379L116.286 67.6288L114.205 101.297L35.1257 96.4066L37.2083 62.7379Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.2835 99.2607C95.2857 99.2603 95.2865 99.2609 95.288 99.2607C95.2873 99.2608 95.2842 99.2606 95.2835 99.2607ZM95.2955 99.2609C95.2971 99.2614 95.3001 99.2616 95.3016 99.2613C95.2987 99.2618 95.2978 99.2612 95.2955 99.2609ZM95.3522 99.2638C97.2866 99.3742 99.1607 99.1346 100.913 98.6014C100.371 98.1195 99.8415 97.6249 99.3267 97.1233C95.7818 93.676 92.2935 89.8093 90.0805 85.3447C87.7138 80.5747 86.5661 75.5281 86.5945 70.5165C83.0345 73.2149 80.6163 77.3766 80.2854 82.1759C80.8899 73.4059 88.4594 66.7519 97.2489 67.2953C103.042 67.6535 107.926 71.0514 110.443 75.8398C108.644 72.4199 105.64 69.7089 101.958 68.3084C101.409 71.7055 101.988 75.1324 103.773 78.4371C105.31 81.2833 107.7 83.9391 110.183 86.352C110.737 86.8889 111.174 87.3132 111.644 87.7139C111.959 86.6154 112.166 85.4675 112.241 84.2816C111.689 93.0732 104.139 99.7636 95.3522 99.2638ZM112.24 84.2801C112.241 84.2755 112.241 84.271 112.241 84.2665C112.241 84.271 112.24 84.2764 112.24 84.2801ZM80.278 82.2895C80.2781 82.2858 80.278 82.2805 80.2787 82.2759C80.278 82.2805 80.278 82.285 80.278 82.2895ZM112.242 84.2544C112.242 84.2537 112.242 84.2521 112.242 84.2514C112.242 84.2528 112.242 84.2528 112.242 84.2544ZM112.243 84.243C112.243 84.2415 112.243 84.2392 112.243 84.2385C112.243 84.2392 112.243 84.2423 112.243 84.243ZM80.2793 82.2578C80.2796 82.2555 80.2797 82.2518 80.28 82.2487C80.2797 82.2518 80.2802 82.2547 80.2793 82.2578ZM80.2814 82.244C80.2816 82.241 80.2819 82.2379 80.2822 82.2356C80.2819 82.2379 80.2815 82.2402 80.2814 82.244ZM112.244 84.2158C112.245 84.215 112.244 84.2158 112.245 84.215L112.244 84.2158ZM80.2821 82.2304C80.2823 82.2274 80.2824 82.2236 80.2827 82.2213C80.2826 82.2251 80.2829 82.2265 80.2821 82.2304ZM112.246 84.1908C112.246 84.1892 112.246 84.1878 112.246 84.187C112.246 84.1878 112.246 84.1901 112.246 84.1908ZM112.247 84.1779C112.246 84.1772 112.247 84.1763 112.247 84.1749C112.247 84.1756 112.246 84.1772 112.247 84.1779ZM112.248 84.1658C112.247 84.1651 112.248 84.1628 112.248 84.1628C112.248 84.1635 112.247 84.1651 112.248 84.1658ZM112.249 84.1506C112.248 84.1492 112.248 84.1492 112.248 84.1484C112.248 84.1492 112.249 84.1506 112.249 84.1506ZM112.251 84.1143C112.251 84.1127 112.251 84.1127 112.251 84.1106C112.251 84.1113 112.251 84.1127 112.251 84.1143ZM112.253 84.0622C112.253 84.0622 112.253 84.0592 112.253 84.0585C112.253 84.0599 112.253 84.0615 112.253 84.0622ZM112.255 84.0094C112.256 84.0086 112.256 84.0079 112.255 84.0071C112.256 84.0086 112.256 84.0086 112.255 84.0094ZM112.258 83.97L112.258 83.9692C112.258 83.9692 112.258 83.9692 112.258 83.97ZM112.26 83.906C112.26 83.9052 112.26 83.9052 112.26 83.9044L112.26 83.906ZM112.262 83.8547C112.262 83.8539 112.262 83.8539 112.263 83.8531L112.262 83.8547ZM110.464 75.8812C110.464 75.8805 110.462 75.8784 110.462 75.8777C110.463 75.8783 110.463 75.8799 110.464 75.8812Z",
    fill: "#E9E9E9",
    fillOpacity: 0.32
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 75,
    width: 3,
    height: 10
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M110.303 75.6929L111.235 75.5326L112.742 84.2858L111.811 84.4461L110.303 75.6929Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2084 62.7379L116.287 67.6289L114.205 101.297L35.1259 96.4066L37.2084 62.7379Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2084 62.7379L116.287 67.6289L114.205 101.297L35.1259 96.4066L37.2084 62.7379Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.243 84.2382C112.243 84.2344 112.244 84.2328 112.244 84.2298C112.244 84.2328 112.243 84.2351 112.243 84.2382ZM112.246 84.1867C112.246 84.1837 112.247 84.1814 112.247 84.1776C112.247 84.1806 112.246 84.1844 112.246 84.1867ZM112.247 84.1746C112.247 84.1715 112.247 84.1678 112.248 84.1654C112.247 84.1685 112.247 84.1715 112.247 84.1746ZM112.248 84.1481C112.249 84.1458 112.249 84.142 112.249 84.1383C112.249 84.142 112.249 84.1443 112.248 84.1481ZM112.25 84.1231C112.25 84.1193 112.251 84.117 112.251 84.114C112.25 84.1156 112.25 84.12 112.25 84.1231ZM112.251 84.1102C112.251 84.1034 112.251 84.0944 112.252 84.0861C112.251 84.0944 112.252 84.1026 112.251 84.1102ZM112.252 84.0831C112.252 84.08 112.252 84.0771 112.252 84.074C112.252 84.0771 112.252 84.0808 112.252 84.0831ZM112.255 84.0197C112.255 84.0166 112.255 84.0129 112.255 84.0091C112.255 84.0129 112.255 84.0159 112.255 84.0197ZM112.256 84.0068C112.256 84.003 112.256 83.9984 112.257 83.9946C112.256 83.9993 112.256 84.003 112.256 84.0068ZM112.257 83.9946C112.257 83.9871 112.258 83.9787 112.258 83.9696C112.257 83.978 112.257 83.9871 112.257 83.9946ZM112.258 83.9689C112.257 83.9653 112.257 83.9608 112.258 83.9577C112.258 83.9615 112.257 83.9653 112.258 83.9689ZM112.26 83.9177C112.26 83.9132 112.26 83.9102 112.26 83.9057C112.26 83.9094 112.26 83.9139 112.26 83.9177ZM112.26 83.9041C112.26 83.9003 112.261 83.8966 112.261 83.8921C112.26 83.8958 112.26 83.9003 112.26 83.9041ZM112.263 83.8527C112.263 83.8483 112.263 83.8452 112.262 83.8409C112.263 83.8445 112.263 83.849 112.263 83.8527ZM112.262 83.8409C112.365 80.9842 111.707 78.2675 110.469 75.8897C111.708 78.2674 112.365 80.9835 112.262 83.8409ZM110.468 75.8884C110.466 75.8857 110.466 75.8828 110.464 75.8809C110.466 75.8835 110.466 75.8857 110.468 75.8884ZM110.457 75.8671C110.456 75.8657 110.456 75.8643 110.455 75.863C110.456 75.865 110.456 75.8657 110.457 75.8671Z",
    fill: "#EBEBEB",
    fillOpacity: 0.15
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 66,
    width: 14,
    height: 23
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M100.974 68.2868L109.727 66.7795L113.287 87.452L104.534 88.9592L100.974 68.2868Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 62.7381L116.286 67.629L114.204 101.298L35.1256 96.4068L37.2082 62.7381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 62.7381L116.286 67.629L114.204 101.298L35.1256 96.4068L37.2082 62.7381Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.644 87.7141C111.174 87.3134 110.737 86.8891 110.183 86.3522C107.7 83.9393 105.31 81.2835 103.773 78.4373C101.988 75.1327 101.409 71.7057 101.958 68.3086C105.64 69.7091 108.644 72.4201 110.443 75.84L110.443 75.8409C110.447 75.8484 110.451 75.8559 110.455 75.8635C110.456 75.8648 110.456 75.8663 110.457 75.8676C110.457 75.8691 110.458 75.8704 110.459 75.8717C110.459 75.8739 110.461 75.8758 110.462 75.8779C110.463 75.8786 110.464 75.8807 110.464 75.8814C110.466 75.8833 110.466 75.8863 110.468 75.8889C110.468 75.8889 110.469 75.8895 110.469 75.8902C111.707 78.2681 112.365 80.9847 112.262 83.8414C112.263 83.8458 112.263 83.8488 112.263 83.8533C112.262 83.8541 112.262 83.8541 112.262 83.8549C112.261 83.8677 112.261 83.8799 112.26 83.8926C112.26 83.8971 112.26 83.9009 112.26 83.9046C112.26 83.9054 112.26 83.9054 112.26 83.9062C112.26 83.9107 112.26 83.9137 112.26 83.9182L112.259 83.9191C112.26 83.9272 112.259 83.9356 112.259 83.9438C112.258 83.9485 112.258 83.9522 112.258 83.956C112.258 83.9567 112.257 83.9576 112.258 83.9583C112.257 83.9613 112.257 83.9658 112.258 83.9695L112.258 83.9702C112.257 83.9793 112.257 83.9877 112.256 83.9952C112.256 83.999 112.256 84.0036 112.255 84.0073C112.256 84.0081 112.256 84.0088 112.255 84.0096C112.255 84.0134 112.255 84.0172 112.255 84.0202C112.255 84.0209 112.255 84.0217 112.254 84.0225C112.255 84.0261 112.255 84.0299 112.255 84.0344C112.254 84.039 112.254 84.0435 112.254 84.0473L112.254 84.048C112.254 84.051 112.253 84.0549 112.253 84.0587C112.253 84.0594 112.253 84.0624 112.253 84.0624C112.253 84.0655 112.252 84.0678 112.252 84.0716C112.252 84.0723 112.252 84.0739 112.252 84.0746C112.252 84.0776 112.252 84.0805 112.251 84.0837C112.252 84.0844 112.252 84.0859 112.252 84.0866C112.251 84.095 112.251 84.104 112.251 84.1108C112.251 84.1129 112.251 84.1129 112.251 84.1145C112.25 84.1176 112.25 84.1199 112.25 84.1236C112.25 84.1244 112.25 84.1251 112.25 84.1259C112.25 84.1297 112.249 84.1327 112.25 84.1349C112.249 84.1358 112.25 84.138 112.249 84.1388C112.249 84.1426 112.249 84.1463 112.248 84.1486C112.248 84.1494 112.248 84.1494 112.249 84.1508C112.248 84.1547 112.248 84.1585 112.248 84.163C112.248 84.163 112.247 84.1653 112.248 84.166C112.247 84.1683 112.247 84.1721 112.247 84.1751C112.247 84.1766 112.247 84.1774 112.247 84.1781C112.247 84.1819 112.246 84.1842 112.246 84.1872C112.246 84.188 112.246 84.1894 112.246 84.191C112.246 84.194 112.245 84.1971 112.245 84.2001C112.245 84.2008 112.245 84.2016 112.245 84.2024C112.245 84.2069 112.245 84.2107 112.245 84.2152C112.244 84.216 112.245 84.2152 112.244 84.216C112.244 84.2198 112.244 84.2235 112.244 84.2273C112.244 84.228 112.244 84.2296 112.244 84.2303C112.243 84.2334 112.243 84.235 112.243 84.2387C112.243 84.2394 112.243 84.2418 112.243 84.2432C112.243 84.2462 112.242 84.2485 112.242 84.2516C112.242 84.2523 112.242 84.2539 112.242 84.2546C112.242 84.2584 112.242 84.2629 112.241 84.2668C112.241 84.2713 112.241 84.2757 112.24 84.2804C112.24 84.2811 112.24 84.2811 112.241 84.2818C112.166 85.4677 111.959 86.6156 111.644 87.7141Z",
    fill: "#D7D7D7",
    fillOpacity: 0.13
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 79,
    width: 17,
    height: 23
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7664 82.1018L92.0581 79.9852L95.3933 99.354L83.1016 101.471L79.7664 82.1018Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 62.7381L116.286 67.629L114.204 101.298L35.1256 96.4068L37.2082 62.7381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 62.7381L116.286 67.629L114.204 101.298L35.1256 96.4068L37.2082 62.7381Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.272 99.2594C95.2758 99.2595 95.2788 99.2597 95.2834 99.2605C95.2796 99.2603 95.2758 99.2595 95.272 99.2594ZM80.2799 82.2485C80.2803 82.2469 80.2806 82.2439 80.2813 82.2438C80.2801 82.2455 80.2802 82.2462 80.2799 82.2485ZM80.2821 82.2354C80.2817 82.2332 80.2821 82.2309 80.282 82.2302C80.2822 82.2316 80.2817 82.2332 80.2821 82.2354ZM80.2826 82.221C80.283 82.2187 80.2827 82.2173 80.2832 82.2157C80.2829 82.218 80.283 82.2187 80.2826 82.221ZM80.2845 82.193C80.285 82.1914 80.2848 82.19 80.2845 82.1885C80.2848 82.19 80.2844 82.1923 80.2845 82.193ZM80.2857 82.1778C80.2856 82.1771 80.2853 82.1756 80.2853 82.1756C80.2856 82.1771 80.2856 82.1771 80.2857 82.1778Z",
    fill: "#EBEBEB",
    fillOpacity: 0.15
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 68,
    width: 24,
    height: 34
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0026 71.8588L95.8814 68.7802L101.045 98.7645L83.1657 101.843L78.0026 71.8588Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M37.208 62.7381L116.286 67.629L114.204 101.298L35.1255 96.4068L37.208 62.7381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M37.208 62.7381L116.286 67.629L114.204 101.298L35.1255 96.4068L37.208 62.7381Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.2719 99.2599C86.4446 98.714 79.7315 91.1149 80.2778 82.2897C80.2778 82.2852 80.2777 82.2808 80.2785 82.2761C80.2782 82.2747 80.2787 82.2731 80.2784 82.2716C80.2788 82.2693 80.2789 82.2656 80.2791 82.2625C80.2796 82.261 80.2792 82.2588 80.2791 82.2581C80.28 82.2549 80.2795 82.252 80.2798 82.2489C80.2801 82.2466 80.28 82.2459 80.2812 82.2442C80.2813 82.2404 80.2816 82.2381 80.282 82.2358C80.2816 82.2336 80.2821 82.2321 80.2818 82.2306C80.2827 82.2267 80.2824 82.2253 80.2825 82.2215C80.2829 82.2192 80.2828 82.2185 80.2831 82.2162C80.2833 82.2131 80.2837 82.2108 80.2832 82.2079C80.2837 82.2063 80.284 82.204 80.2839 82.2033C80.284 82.1995 80.2843 82.1972 80.2844 82.1935C80.2843 82.1927 80.2847 82.1904 80.2844 82.189C80.2845 82.1852 80.2853 82.1813 80.2856 82.1783C80.2854 82.1776 80.2854 82.1776 80.2852 82.1761C80.6161 77.3768 83.0343 73.2151 86.5943 70.5167C86.5659 75.5283 87.7136 80.5749 90.0803 85.3449C92.2933 89.8095 95.7816 93.6762 99.3265 97.1235C99.8413 97.6251 100.371 98.1197 100.913 98.6016C99.1605 99.1348 97.2864 99.3744 95.352 99.2641C95.3482 99.264 95.3459 99.2636 95.3422 99.2635C95.3414 99.2636 95.34 99.2639 95.3393 99.264C95.3362 99.2638 95.3339 99.2634 95.331 99.2639C95.3294 99.2634 95.3287 99.2636 95.3264 99.2632C95.3249 99.2635 95.3219 99.2632 95.3196 99.2629C95.3173 99.2625 95.3158 99.2628 95.3143 99.2623C95.3121 99.2627 95.3098 99.2623 95.3075 99.262C95.306 99.2622 95.303 99.262 95.3014 99.2615C95.2999 99.2618 95.2969 99.2616 95.2953 99.2611C95.2931 99.2615 95.2908 99.2611 95.2878 99.2609C95.2863 99.2611 95.2855 99.2605 95.2833 99.2609C95.2787 99.2602 95.2757 99.26 95.2719 99.2599Z",
    fill: "#D7D7D7",
    fillOpacity: 0.13
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 62,
    width: 38,
    height: 38
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7822 67.4511L68.0702 62.0635L73.5541 93.9102L42.2661 99.2979L36.7822 67.4511Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2084 62.7381L116.287 67.6291L114.205 101.298L35.1259 96.4068L37.2084 62.7381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2084 62.7381L116.287 67.6291L114.205 101.298L35.1259 96.4068L37.2084 62.7381Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9339 96.7031C54.9982 96.7677 56.0425 96.725 57.0594 96.5881C54.7271 92.6399 52.7186 88.4666 51.6325 83.9907C50.0875 77.6238 50.1308 71.2546 51.421 65.0923C44.7384 66.5831 39.5388 72.271 38.9525 79.4019C39.6654 70.7398 47.1818 64.1991 55.8985 64.7378C64.6858 65.2816 71.3789 72.8174 70.8987 81.5953C71.1615 76.7965 69.277 72.3734 66.0824 69.2553C65.4633 73.1117 65.605 77.0619 66.6416 80.8332C67.2799 83.1525 68.2955 85.3222 69.4514 87.4235C70.2503 85.6904 70.7561 83.7861 70.8882 81.7694C70.312 90.56 62.735 97.24 53.9339 96.7031ZM70.892 81.7088C70.892 81.7043 70.892 81.6998 70.8927 81.6952C70.892 81.6998 70.8921 81.705 70.892 81.7088ZM38.9287 79.7206C38.929 79.7183 38.9289 79.7176 38.9295 79.7167C38.9289 79.7176 38.9293 79.7197 38.9287 79.7206ZM38.9305 79.6963C38.9309 79.694 38.9307 79.6933 38.9305 79.6918C38.9307 79.6933 38.9302 79.6949 38.9305 79.6963ZM38.9319 79.6826C38.9319 79.6826 38.9324 79.681 38.9321 79.6796C38.9324 79.681 38.9325 79.6817 38.9319 79.6826ZM70.896 81.6362C70.8961 81.6324 70.8964 81.6301 70.8967 81.6271C70.8966 81.6308 70.8961 81.6324 70.896 81.6362ZM38.9342 79.6567C38.9338 79.6545 38.9343 79.653 38.9341 79.6522C38.9337 79.6538 38.9338 79.6545 38.9342 79.6567ZM38.9343 79.6447C38.9347 79.6424 38.9345 79.641 38.9349 79.6394C38.9345 79.641 38.9348 79.6431 38.9343 79.6447ZM38.935 79.6311C38.9356 79.6303 38.9355 79.6295 38.936 79.628C38.9355 79.6295 38.9355 79.6295 38.935 79.6311ZM38.9383 79.5804C38.9386 79.5781 38.9391 79.5765 38.9387 79.5743C38.9391 79.5765 38.9387 79.5788 38.9383 79.5804ZM38.9393 79.569C38.9396 79.5667 38.9393 79.5645 38.9397 79.5629C38.9399 79.5636 38.939 79.5675 38.9393 79.569ZM38.9402 79.5568C38.9411 79.5537 38.9414 79.5506 38.9416 79.5476C38.9414 79.5506 38.941 79.5529 38.9402 79.5568ZM38.9418 79.5401C38.9421 79.5378 38.9419 79.5363 38.9422 79.534C38.942 79.537 38.9421 79.5378 38.9418 79.5401ZM38.9427 79.5279C38.9426 79.5272 38.9428 79.5242 38.9433 79.5226C38.9428 79.5242 38.9431 79.5256 38.9427 79.5279ZM38.948 79.4543C38.9482 79.4513 38.9483 79.4476 38.9487 79.4452C38.9485 79.4483 38.9481 79.4506 38.948 79.4543ZM38.949 79.4429C38.9504 79.4292 38.9512 79.4163 38.9519 79.4027C38.9512 79.4163 38.9505 79.4299 38.949 79.4429Z",
    fill: "#E9E9E9",
    fillOpacity: 0.32
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 68,
    width: 9,
    height: 20
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5367 69.3837L69.1927 68.582L72.3676 87.0196L67.7116 87.8213L64.5367 69.3837Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2083 62.7383L116.286 67.6293L114.205 101.298L35.1257 96.407L37.2083 62.7383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2083 62.7383L116.286 67.6293L114.205 101.298L35.1257 96.407L37.2083 62.7383Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4512 87.4239C68.2953 85.3225 67.2798 83.1528 66.6415 80.8335C65.6048 77.0622 65.4632 73.1121 66.0823 69.2557C69.2769 72.3737 71.1613 76.7968 70.8985 81.5956C70.8988 81.5971 70.8988 81.5971 70.8982 81.5979C70.8981 81.6017 70.898 81.6054 70.8979 81.6092C70.898 81.6099 70.8975 81.6115 70.8976 81.6122C70.8975 81.616 70.8973 81.619 70.8972 81.6228C70.8966 81.6237 70.897 81.6258 70.8965 81.6274C70.8963 81.6305 70.8959 81.6328 70.8958 81.6365C70.896 81.6373 70.8957 81.6403 70.8959 81.641C70.8955 81.6433 70.8954 81.6471 70.8952 81.6501C70.8953 81.6509 70.895 81.6532 70.8946 81.6555C70.895 81.6576 70.8948 81.6607 70.8945 81.6637C70.8941 81.6653 70.8942 81.666 70.8939 81.6691C70.8936 81.6714 70.8941 81.6743 70.8937 81.6766C70.8934 81.6789 70.8936 81.6803 70.8933 81.6827C70.8929 81.685 70.8928 81.6887 70.8925 81.691C70.8929 81.6932 70.8923 81.6941 70.8925 81.6955C70.8918 81.7001 70.8918 81.7046 70.8919 81.7091C70.8912 81.7137 70.8911 81.7175 70.8911 81.722C70.8906 81.7236 70.8904 81.7266 70.89 81.7289C70.8903 81.7304 70.8899 81.7327 70.8902 81.7341C70.8898 81.7364 70.8895 81.7387 70.8892 81.7418C70.8895 81.7432 70.8897 81.7447 70.8893 81.7463C70.8889 81.7486 70.8888 81.7523 70.8886 81.7554C70.8888 81.7568 70.8888 81.7568 70.8882 81.7577C70.8881 81.7614 70.888 81.7652 70.8879 81.769L70.8881 81.7697C70.7559 83.7865 70.2501 85.6908 69.4512 87.4239Z",
    fill: "#D7D7D7",
    fillOpacity: 0.13
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 77,
    width: 17,
    height: 22
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M38.276 79.4666L50.754 77.318L54.0892 96.6867L41.6112 98.8354L38.276 79.4666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2083 62.7382L116.286 67.6291L114.205 101.298L35.1257 96.4069L37.2083 62.7382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2083 62.7382L116.286 67.6291L114.205 101.298L35.1257 96.4069L37.2083 62.7382Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9321 79.68C38.9323 79.677 38.933 79.6724 38.9331 79.6686C38.9332 79.6731 38.9329 79.6761 38.9321 79.68ZM38.9334 79.6656C38.9337 79.6633 38.9338 79.6595 38.9342 79.6572C38.9338 79.6595 38.9336 79.6625 38.9334 79.6656ZM38.9349 79.6398C38.9352 79.6368 38.9355 79.6345 38.935 79.6316C38.9355 79.6345 38.9347 79.6384 38.9349 79.6398ZM38.9376 79.5989C38.9374 79.5975 38.9377 79.5952 38.938 79.5921C38.9379 79.5959 38.9373 79.5967 38.9376 79.5989ZM38.9387 79.5748C38.9391 79.5725 38.9389 79.5717 38.9393 79.5694C38.9394 79.5701 38.9392 79.5732 38.9387 79.5748ZM38.9416 79.548C38.9418 79.545 38.9415 79.5428 38.9418 79.5405C38.9416 79.5436 38.9418 79.545 38.9416 79.548ZM38.9423 79.5344C38.9427 79.5329 38.9422 79.53 38.9427 79.5284C38.9424 79.5307 38.9427 79.5329 38.9423 79.5344ZM38.9433 79.523C38.9429 79.5209 38.9433 79.5185 38.9436 79.5162C38.9434 79.5193 38.9435 79.52 38.9433 79.523ZM38.9444 79.4989C38.9448 79.4973 38.9446 79.4958 38.9445 79.4951C38.9446 79.4958 38.9447 79.4966 38.9444 79.4989ZM38.9463 79.4798C38.9469 79.479 38.9468 79.4782 38.9466 79.4768C38.9468 79.4782 38.9468 79.4782 38.9463 79.4798ZM38.9475 79.4691C38.9472 79.4677 38.9471 79.4669 38.9476 79.4654C38.9477 79.4661 38.9472 79.4677 38.9475 79.4691ZM38.9477 79.4571C38.9483 79.4563 38.948 79.4548 38.948 79.4548C38.9481 79.4555 38.9483 79.4563 38.9477 79.4571ZM38.9487 79.4457L38.9491 79.4434C38.9486 79.445 38.9487 79.4457 38.9487 79.4457Z",
    fill: "#EBEBEB",
    fillOpacity: 0.15
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 64,
    width: 22,
    height: 36
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2235 67.5472L51.6813 64.8855L57.1651 96.7322L41.7074 99.3939L36.2235 67.5472Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2083 62.738L116.286 67.6289L114.205 101.298L35.1257 96.4067L37.2083 62.738Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2083 62.738L116.286 67.6289L114.205 101.298L35.1257 96.4067L37.2083 62.738Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9217 96.7024C45.0944 96.1565 38.3822 88.558 38.9284 79.7322C38.9285 79.7284 38.9284 79.7239 38.9287 79.7209C38.9293 79.72 38.9289 79.7178 38.9295 79.717C38.929 79.7141 38.9293 79.7118 38.9296 79.7087C38.93 79.7072 38.9298 79.7057 38.9295 79.7042C38.9299 79.7019 38.9301 79.6989 38.9305 79.6966C38.9302 79.6951 38.9307 79.6936 38.9305 79.6921C38.9314 79.6889 38.9318 79.6866 38.9319 79.6829C38.9325 79.682 38.9323 79.6813 38.9321 79.6798C38.9329 79.6759 38.9331 79.6729 38.9331 79.6684C38.933 79.6677 38.9329 79.667 38.9333 79.6654C38.9336 79.6623 38.9338 79.6593 38.9341 79.657C38.9338 79.6548 38.9336 79.6541 38.9341 79.6525C38.9344 79.6495 38.9347 79.6472 38.9343 79.645C38.9348 79.6434 38.9344 79.6412 38.9349 79.6396C38.9347 79.6382 38.9355 79.6343 38.935 79.6314C38.9355 79.6298 38.9355 79.6298 38.9359 79.6282C38.9354 79.6253 38.9363 79.6214 38.9359 79.6193C38.9364 79.6177 38.9362 79.6169 38.9367 79.6154C38.9368 79.6116 38.9369 79.6078 38.9371 79.6048C38.9368 79.6026 38.9372 79.601 38.9376 79.5987C38.9372 79.5966 38.9378 79.5957 38.9379 79.5919C38.9378 79.5912 38.938 79.5882 38.9385 79.5866C38.9381 79.5844 38.9386 79.5828 38.9382 79.5806C38.9387 79.5791 38.9391 79.5768 38.9387 79.5746C38.9392 79.573 38.9394 79.57 38.9393 79.5692C38.939 79.5678 38.9398 79.5639 38.9397 79.5632C38.9399 79.5601 38.9397 79.5587 38.9402 79.5571C38.941 79.5532 38.9413 79.5509 38.9416 79.5479C38.9418 79.5448 38.9415 79.5434 38.9418 79.5403C38.9421 79.538 38.942 79.5373 38.9422 79.5343C38.9427 79.5327 38.9423 79.5305 38.9427 79.5282C38.943 79.5259 38.9428 79.5244 38.9433 79.5229C38.9435 79.5198 38.9434 79.5191 38.9436 79.5161C38.9433 79.5146 38.9438 79.513 38.9434 79.5108C38.9439 79.5093 38.9441 79.5062 38.9439 79.5048C38.9444 79.5032 38.944 79.501 38.9443 79.4987C38.9447 79.4964 38.9446 79.4957 38.9444 79.4949C38.9457 79.4895 38.9463 79.4841 38.9463 79.4796C38.9468 79.4781 38.9468 79.4781 38.9465 79.4766C38.9469 79.4743 38.9471 79.4713 38.9475 79.4689C38.9472 79.4675 38.9477 79.4659 38.9476 79.4652C38.9478 79.4621 38.9481 79.4598 38.9476 79.4569C38.9482 79.4561 38.9481 79.4554 38.948 79.4546C38.9481 79.4509 38.9484 79.4486 38.9487 79.4455C38.9487 79.4455 38.9485 79.4448 38.949 79.4432C38.9505 79.4302 38.9512 79.4166 38.9518 79.403L38.9524 79.4022C39.5388 72.2712 44.7384 66.5834 51.421 65.0926C50.1308 71.2548 50.0875 77.6241 51.6325 83.991C52.7186 88.4669 54.7271 92.6401 57.0594 96.5884C56.0425 96.7252 54.9982 96.768 53.9339 96.7033C53.9294 96.7034 53.9263 96.7031 53.9217 96.7024Z",
    fill: "#D7D7D7",
    fillOpacity: 0.13
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 76,
    width: 13,
    height: 9
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M69.088 77.9962L80.0761 76.1041L81.2626 82.9949L70.2746 84.887L69.088 77.9962Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2085 62.7382L116.287 67.6292L114.205 101.298L35.126 96.4069L37.2085 62.7382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2085 62.7382L116.287 67.6292L114.205 101.298L35.126 96.4069L37.2085 62.7382Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6819 82.4457C71.7482 81.3781 72.2378 80.4451 72.9815 79.7874C73.726 79.1304 74.7122 78.7591 75.7812 78.8244C76.8504 78.8913 77.7834 79.3808 78.4411 80.1252C79.0982 80.8697 79.4686 81.8554 79.4031 82.9236L81.0695 83.0262C81.1633 81.5044 80.6288 80.0796 79.6913 79.0201C78.7558 77.9594 77.4081 77.2537 75.8839 77.1588C74.3607 77.0653 72.9358 77.5998 71.877 78.5372C70.8164 79.4726 70.1106 80.8204 70.017 82.3428L71.6819 82.4457Z",
    fill: "#350E52",
    fillOpacity: 0.43
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 78,
    width: 5,
    height: 5
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6302 78.5798L38.9825 78.0026L39.7201 82.2861L36.3678 82.8633L35.6302 78.5798Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M37.208 62.7376L116.286 67.6286L114.204 101.297L35.1255 96.4063L37.208 62.7376Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M37.208 62.7376L116.286 67.6286L114.204 101.297L35.1255 96.4063L37.208 62.7376Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 80.4087C38.6886 81.5255 39.1674 82.4617 38.0514 82.3925C36.9362 82.3239 36.0872 81.3652 36.1562 80.2477C36.2248 79.1325 37.1857 78.2831 38.3009 78.3518C39.4177 78.4209 38.8263 79.2935 38.7577 80.4087Z",
    fill: "#350E52",
    fillOpacity: 0.43
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 82,
    width: 5,
    height: 6
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M111.772 83.1103L114.938 82.5651L115.644 86.6624L112.478 87.2076L111.772 83.1103Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M37.208 62.7381L116.286 67.629L114.204 101.298L35.1255 96.4068L37.208 62.7381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M37.208 62.7381L116.286 67.629L114.204 101.298L35.1255 96.4068L37.208 62.7381Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.603 84.9765C112.673 83.8612 112.194 82.9226 113.31 82.9919C114.425 83.0605 115.274 84.0223 115.206 85.1374C115.136 86.2551 114.175 87.1014 113.06 87.0327C111.944 86.9635 112.534 86.094 112.603 84.9765Z",
    fill: "#350E52",
    fillOpacity: 0.43
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 61,
    width: 40,
    height: 40
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3503 66.9307L68.687 61.1903L74.4274 94.5269L41.0908 100.267L35.3503 66.9307Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 62.7382L116.286 67.6291L114.204 101.298L35.1256 96.4069L37.2082 62.7382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 62.7382L116.286 67.6291L114.204 101.298L35.1256 96.4069L37.2082 62.7382Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.8918 81.7089L70.059 81.6576C69.7992 85.8431 67.8721 89.5203 64.9595 92.0945C62.0453 94.6674 58.1589 96.1277 53.9729 95.8695C49.7873 95.6097 46.11 93.6818 43.5351 90.7694C40.963 87.8558 39.5028 83.9694 39.761 79.7834C40.0208 75.5978 41.9487 71.9213 44.8603 69.3457C47.7745 66.7728 51.6609 65.3125 55.8469 65.5707C60.0325 65.8305 63.7091 67.7585 66.2847 70.6708C68.8577 73.585 70.3165 77.4717 70.059 81.6576L71.7239 81.7604C72.0109 77.1199 70.3882 72.7941 67.535 69.5663C64.683 66.3368 60.5901 64.1922 55.9498 63.9058C51.3092 63.618 46.9836 65.2423 43.7558 68.0955C40.5256 70.9476 38.3824 75.0402 38.0953 79.6807C37.8083 84.3211 39.4309 88.6462 42.2848 91.8739C45.1368 95.1034 49.2297 97.248 53.8694 97.5352C58.5099 97.8223 62.8362 96.1979 66.064 93.3447C69.2935 90.4927 71.4368 86.4008 71.7239 81.7604L70.8918 81.7089Z",
    fill: "#350E52",
    fillOpacity: 0.43
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 63,
    width: 40,
    height: 40
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6226 69.412L110.145 63.6395L115.918 97.1623L82.395 102.935L76.6226 69.412Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1_9851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1_9851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 82,
    height: 40
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 62.7385L116.286 67.6295L114.204 101.298L35.1256 96.4072L37.2082 62.7385Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.241 84.2669L111.409 84.2154C111.15 88.4009 109.222 92.0781 106.309 94.6523C103.396 97.2252 99.5088 98.6855 95.3235 98.4272C91.1364 98.1677 87.4599 96.2397 84.885 93.3273C82.3128 90.4136 80.8526 86.5273 81.1116 82.3411C81.3699 78.1558 83.2985 74.4784 86.2101 71.9036C89.1244 69.3306 93.0108 67.8704 97.1975 68.1285C101.382 68.3884 105.06 70.3161 107.634 73.2288C110.208 76.1429 111.668 80.0293 111.409 84.2154L113.074 84.3181C113.362 79.6777 111.738 75.352 108.884 72.1243C106.033 68.8947 101.941 66.7499 97.3004 66.4636C92.6591 66.1759 88.3334 67.7994 85.105 70.6534C81.8762 73.5053 79.7323 77.5981 79.4452 82.2385C79.1581 86.879 80.7822 91.2038 83.6347 94.4317C86.4867 97.6612 90.5789 99.806 95.2208 100.093C99.8612 100.38 104.186 98.7558 107.414 95.9026C110.643 93.0506 112.788 88.9584 113.074 84.3181L112.241 84.2669Z",
    fill: "#350E52",
    fillOpacity: 0.43
  }))))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0139 168.576C97.2904 167.561 98.3333 166.965 99.3452 167.24L107.655 169.5C108.667 169.774 109.268 170.82 108.993 171.834L104.186 189.588C103.175 193.316 100.939 192.707 99.9265 192.432L94.3679 190.922C93.3531 190.644 91.1998 190.059 92.2062 186.334L97.0139 168.576Z",
    fill: "#EF2F3B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 101.866L127.054 105.12L106.35 181.589L94.3729 178.334L115.074 101.866Z",
    fill: "#D27E1C"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M118.554 102.81L123.571 104.174L102.872 180.641L97.8503 179.28L118.554 102.81Z",
    fill: "#F8A229"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 101.866C115.074 101.866 122.867 86.5115 125.469 87.2187C128.073 87.9263 127.054 105.12 127.054 105.12L115.074 101.866Z",
    fill: "#FBC8A6"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 96.1291C127.147 91.8408 126.741 87.5646 125.469 87.2186C124.197 86.8735 121.69 90.3584 119.455 94.0143L127.232 96.1291Z",
    fill: "#25BA72"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0133 168.576L108.992 171.834L106.35 181.589L94.3726 178.334L97.0133 168.576Z",
    fill: "#AED5E5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M203.36 203.75C176.483 203.75 154.695 199.603 154.695 194.488C154.695 189.373 176.483 185.227 203.36 185.227C230.237 185.227 252.025 189.373 252.025 194.488C252.025 199.603 230.237 203.75 203.36 203.75Z",
    fill: "black",
    fillOpacity: 0.38
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_9851",
    x: 82.5445,
    y: 124.049,
    width: 30.1402,
    height: 16.6206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.365332,
    dy: 0.365332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0333333 0 0 0 0 0.0333333 0 0 0 0 0.0333333 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_9851",
    x: 60.6749,
    y: 151.148,
    width: 30.4775,
    height: 43.2858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.365332,
    dy: 0.365332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_9851",
    x: 25.4362,
    y: 147.534,
    width: 30.2239,
    height: 48.5424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.365332,
    dy: 0.365332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1_9851",
    x: 25.4384,
    y: 147.548,
    width: 30.2217,
    height: 48.5289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.365332,
    dy: 0.365332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1_9851",
    x: 35.7904,
    y: 111.701,
    width: 52.9731,
    height: 52.2833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.365332,
    dy: 0.365332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.233333 0 0 0 0 0.233333 0 0 0 0 0.233333 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1_9851",
    x: 24.127,
    y: 50.2614,
    width: 89.7363,
    height: 67.6171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.365332,
    dy: 0.365332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141667 0 0 0 0 0.141076 0 0 0 0 0.141076 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1_9851",
    x: 19.8319,
    y: 117.378,
    width: 28.8406,
    height: 27.1007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.365332,
    dy: 0.365332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_9851",
    x1: 55.7906,
    y1: 173.98,
    x2: 27.75,
    y2: 170.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_9851",
    x1: 85.6817,
    y1: 143.757,
    x2: 37.7726,
    y2: 131.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_9851",
    x1: 111.227,
    y1: 89.5199,
    x2: 25.4704,
    y2: 78.4826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfinandoTourComplete);
export default __webpack_public_path__ + "static/media/afinando_tour_complete.e35061789bd9410851fcb409f1185b29.svg";
export { ForwardRef as ReactComponent };